export type ProductKind =
  | "retail"
  | "production"
  | "hybrid"
  | "online-showcase";

export const PRODUCT_KIND_LABELS: Record<
  ProductKind,
  { label: string; hint: string }
> = {
  retail: {
    label: "ສິນຄ້າຂາຍ",
    hint: "ສະແດງໃນຮ້ານ · ສັ່ງຊື້ໄດ້",
  },
  production: {
    label: "ແບບຮັບຜະລິດ",
    hint: "About Showcase · ບໍ່ຂາຍ",
  },
  "online-showcase": {
    label: "ແບບສິນຄ້າອອນໄລນ໌",
    hint: "About Showcase · ບໍ່ຂາຍ",
  },
  hybrid: {
    label: "ທັງສອງແບບ",
    hint: "ຮ້ານ + Showcase",
  },
};

export function productKindToFlags(kind: ProductKind): {
  isSellable: boolean;
  isShowcaseEligible: boolean;
} {
  if (kind === "production" || kind === "online-showcase") {
    return { isSellable: false, isShowcaseEligible: true };
  }
  if (kind === "hybrid") {
    return { isSellable: true, isShowcaseEligible: true };
  }
  return { isSellable: true, isShowcaseEligible: false };
}

/** อ่านค่า radio จาก flags จริงใน DB (กรณีข้อมูลเก่าไม่ตรง kind) */
export function inferProductKind(
  kind: ProductKind | undefined,
  isSellable: boolean,
  isShowcaseEligible: boolean,
): ProductKind {
  if (kind === "online-showcase") return "online-showcase";
  if (isSellable && isShowcaseEligible) return "hybrid";
  if (isShowcaseEligible && !isSellable) return "production";
  if (isSellable && !isShowcaseEligible) return "retail";
  return kind ?? "retail";
}
